var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ButtonGroup as KendoButtonGroup } from '@progress/kendo-react-buttons';
var StyledButtonGroup = styled(KendoButtonGroup)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

/**
 * The KendoReact ButtonGroup is a container for two or more Button components that you
 * can configure individually. Each button can display textual content, predefined
 * icons, images, custom icons, or render a combination of textual and image content.
 */
var ButtonGroup = props => /*#__PURE__*/React.createElement(StyledButtonGroup, props);
ButtonGroup.defaultProps = {
  children: undefined,
  className: undefined,
  dir: undefined,
  disabled: false,
  width: undefined
};
ButtonGroup.propTypes = {
  /**
   * Represents the children that are passed to the ButtonGroup.
   */
  children: PropTypes.node,
  /**
   * Sets the className of the ButtonGroup component.
   */
  className: PropTypes.string,
  /**
   * Sets the direction of the ButtonGroup.
   */
  dir: PropTypes.string,
  /**
   * By default, the ButtonGroup is enabled. To disable the whole group of buttons,
   * set its disabled attribute to true. To disable a specific button, set its own
   * disabled attribute to true and leave the disabled attribute of the ButtonGroup undefined.
   * If you define the disabled attribute of the ButtonGroup, it will take precedence over
   * the disabled attributes of the underlying buttons and they will be ignored.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the width of the ButtonGroup.
   * If the width of the ButtonGroup is set:
   * The buttons resize automatically to fill the full width of the group wrapper.
   * The buttons acquire the same width.
   */
  width: PropTypes.string
};
export default ButtonGroup;